<template>
	<div>
		<div v-if="page" :class="{'bg-pink': page.theme == 'pink'}">

            <div class="grid grid-cols-12 pt-21 md:pt-25" v-if="page.text || page.textEnglish">
                <div class="col-span-12 md:mb-14 max-md:mt-1">
                    <h1 class="headline-big">{{page.title}} <span v-if="page.titleEnglish" class="font-serif">/</span> <span v-if="page.titleEnglish" class="text-gray-dark">{{page.titleEnglish}}</span></h1>
                </div>
                <div class="col-span-12 md:col-span-6 text-big page-text" v-html="page.text"></div>
                <div class="col-span-12 md:col-span-6 text-big page-text text-gray-dark" v-html="page.textEnglish"></div>
            </div>

			<Hero
                :label="!page.text || !page.textEnglish ? page.title : null"
                :labelEnglish="page.titleEnglish"
                :media="page.promotedEvent[0].media[0]"
                :title="page.promotedEvent[0].title"
                :dateFrom="page.promotedEvent[0].dateFrom"
                :dateTo="page.promotedEvent[0].dateTo"
                :stage="page.promotedEvent[0].stage[0].title"
                :theme="page.theme"
                :imageLayout="page.imageLayout"
                :url="`/event/${page.promotedEvent[0].slug}`"
                v-if="page.promotedEvent.length > 0"
            />

            <div class="grid grid-cols-12 pb-8 md:pb-12 pt-20 md:pt-22">
                <div class="col-span-12">
                    <h2 :class="page.promotedEvent.length > 0 ? 'headline' : 'headline-big mb-10 mt-10'">{{page.title}} <span v-if="page.titleEnglish" class="font-serif">/</span> <span v-if="page.titleEnglish" class="text-gray-dark">{{page.titleEnglish}}</span></h2>
                </div>
            </div>

            <div :class="{'mb-20': page.filtering && page.filtering[0] == 'addFilter'}">
                <div class="index-grid grid grid-cols-12 pb-21 md:pb-24" v-if="events">
                    <template v-for="(event, index) in events" :key="index">
                        <div class="col-span-12 md:col-span-6" v-if="page.grid == '2Columns' && isInFilter(event)">
                            <ElementCard :data="event"/>
                        </div>

                        <div class="col-span-12 md:col-span-4" v-if="page.grid == '3Columns' && isInFilter(event)">
                            <ElementCard :data="event"/>
                        </div>
                    </template>
                </div>

                <div class="index-grid grid grid-cols-12 sticky bottom-10 -mt-6 md:mt-20 max-md:pl-0 max-md:pr-0 max-md:overflow-hidden" v-if="events && page.filtering && page.filtering[0] == 'addFilter'">
                    <div class="col-span-12">
                        <CalendarFilter :events="events"/>
                    </div>
                </div>
            </div>
		</div>
	</div>
</template>

<script setup>
import { eventsQuery, eventsListQuery } from '@/api/queries'
import { onMounted } from 'vue';
const config = useRuntimeConfig();
const route = useRoute();

const page = ref(null)
const events = ref(null)
const filter = ref(null)

const isInFilter = (event) => {
    if (filter.value) {
        return event.category.some(category => category.slug === filter.value)
    }

    return true
}

watch(() => route.query.category, () => {
    if (events.value && page.value.filtering && page.value.filtering[0] == 'addFilter') {
        if (route.query.category) {
            filter.value = route.query.category
        } else {
            filter.value = null
        }
    }
}, { immediate: true, deep: true })

watch(page, async () => {
    if (page.value && page.value.category) {
        query = eventsListQuery(page.value.category)

        const { data: gqlEvents } = await useFetch(config.public.API, {
            params: { query, token },
        });

        if (gqlEvents.value) {
            events.value = gqlEvents.value.data.eventsEntries;
        }
    }
})

if (route.query.category) {
    filter.value = route.query.category
}

// Build the URL, with `query` and `token` params:
let query = eventsQuery(route.params.slug[0])
const token = route.query.token;
const getData = async () => {
    const { data: gql } = await useFetch(config.public.API, {
        params: { query, token },
    });

    // Extract the first page from the response:
    if (gql.value) {
        page.value = gql.value.data.calendarPagesEntries[0];
    }
}

await getData()

onMounted(() => {
    if (!page.value) {
        getData();
    }
})

const seoTitle = page?.value?.title && page?.value?.titleEnglish ? `${page?.value?.title} / ${page?.value?.titleEnglish}` : page?.value?.title

useHead({
	title: `Sydhavn Teater — ${seoTitle}`,
	meta: [
		{ hid: 'og:title', property: 'og:title', content: `Sydhavn Teater — ${seoTitle}` },
	],
});
</script>

<style lang="scss" scoped>
.index-grid.grid {
    @apply gap-y-20 md:gap-y-21;
}

.page-text :deep(*):not(:last-child) {
    margin-bottom: 1em;
}
</style>